<template>
  <van-list
    :value="loading"
    :finished="finished"
    :finished-text="finishedText"
    @load="onLoad"
  >
  <div class="goods" >
    <div v-for="item of goodsList" :key="item[filename.goods_id]" class="goods-item" @click="selectedGoods(item)">
      <div class="goods-img">
        <img :src="item[filename.goods_img]">
      </div>
      <div class="goods-describe">
        <div class="goods-name">{{ item[filename.goods_name] }}</div>
        <div class="goods-desc"> {{ item[filename.goods_description] }} </div>
        <div class="goods-price">
          <price-convert :price="item[filename.goods_price]"></price-convert>
          <!-- {{ item.goods_price }} -->
        </div>
      </div>
    </div>
  </div>
  </van-list>
</template>
<script>
const names = {
  goods_id: 'goods_id',
  goods_name: 'goods_name',
  goods_img: 'goods_img',
  goods_price: 'goods_price',
  goods_description: 'goods_description'
}

export default {
  model: {
    prop: 'loading',
    event: 'load-more'
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    finished: {
      type: Boolean,
      default: true
    },
    finishedText: {
      type: String,
      default: '没有更多了'
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectGoods: {
      type: Function,
      // default: () => {
      //   return ''
      // }
    },
    fieldNames: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // refresh: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data () {
    return {
    time: null
    }
  },
  computed: {
    filename () {
      for (let key in this.fieldNames) {
        names[key] = this.fieldNames[key]
      }
      return names
    },
    // 处理流式瀑布流排序问题
    goodsList () {
      const list = []
      const list2 = this.list.filter((item, index) => {
        if ((index+1) % 2 != 0) {
          list.push(item)
        } else {
          return item
        }

      })
      // console.log(list2);
      // const list = this.list.map((item, index) => {
      //   if ((index + 1) % 2 === 0) {

      //   }
      // })
      // 根据 this.list index下标奇偶数 进行排序
    //   const list = this.list.reduce((acc, element, index) => {
    //     (index % 2 === 0 ? acc.even : acc.odd).push(element);
    // return acc;
    //   }, { odd: [], even: [] }).odd.concat({ even: [] }).even;
    //     console.log(list);
      return [...list, ...list2]
    }
  },
  methods: {
    onLoad () {
      if (this.time !== null) {
        clearTimeout(this.time);
      } 
        this.time = setTimeout(() => {
              this.$emit('load')
                //这里的this指向的是input
          },500)
      
    },
    selectedGoods (item) {
      if (this.selectGoods) {
        this.selectGoods(item)
        return
      }
      console.log(item[this.filename.goods_id]);
      this.$router.push({
        name: 'prodetail',
        query: { pid: item[this.filename.goods_id] }
      })
      // console.log(this.selectGoods);
      // this.$router.push()
      // this.$emit('select-goods', item)
    }
  },
  
}
</script>
<style lang="scss" scoped>
  .goods{
    width: $cake-box-width;
    margin: 10px auto;
    // display: flex;
    // gap: 10px;
    // justify-content: space-between;
    // flex-wrap: wrap;
    column-count: 2; // 定义三列
    column-gap: 0.2rem;
    // flex-flow:column wrap;
    // column-gap: normal;
    // &:after{
    //   content: '';
    //   flex-grow: 99999;
    // }
    .goods-item {
      // flex-grow: 1;
      break-inside: avoid;
      width: 3.31rem;
      background: #fff;
      // margin: 10px 0;
      margin-bottom: 10px;
      border-radius: 12px;
      .goods-img {
        width: 3.31rem;
        height: 3.27rem;
        border-radius: 12px;
        img {
          border-radius: 10px;
        }
      }
      .goods-describe{
        font-size: 0.24rem;
        padding: 10px;
        .goods-name {
          color: $cake-text-back;
          font-weight: 600;
        }
        .goods-desc{
          font-size: 0.2rem;
          color: $cake-text-grey;
          margin: 0.06rem 0;
        }
        .goods-price {
          color: $cake-primary-color;
          font-weight: 600;
        }
      }
    }
  }
 
</style>